import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { getMBMPointData } from "services/ConfigServices";
import { methodData, displayData, monthnameData, displayDataOnlyTab } from "variables/MBM/lists/pointdata";
import { pointdatapagetext } from "variables/MBM/pointdata";
import { dico } from "variables/lists/dico";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import zipcelx from 'zipcelx';
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import 'moment/locale/fr';
import { CSVLink } from "react-csv";

const downloadCsvButton = {
  textDecoration: 'none',
  color: 'rgb(0 0 0 / 87%)'
}
const menuItemStyle = {
  fontSize: '1.2rem',
  fontFamily: '"Source Sans Pro",sans-serif',
}
const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "-0.5rem",
  paddingTop: "9px",
  fontFamily: '"Source Sans Pro",sans-serif',
};
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const HighchartsContainer = styled.div`
  margin-top: 1.5rem;
  margin-right: 1rem;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewPointDataDialog(props) {
  const { closeModal, point } = props;
  const chartRef = React.useRef(null);
  const [openMenu, setOpenMenu] = React.useState(null);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvLines, setCsvLines] = useState([]);
  const [method, setMethod] = useState("raw");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'month').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [display, setDisplay] = useState("tab");
  const [data, setData] = useState([]);
  const [highchartData, setHighchartData] = useState([]);
  const [datesdata, setDatesdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [daterange, setDaterange] = useState("0");
  const classes = useStyles();

  const handleMethodChange = (event) => {
    if (method === 'raw') {
      setDatebegin(datesdata.find((obj) => obj.id === "0").datebegin);
      setDateend(datesdata.find((obj) => obj.id === "0").dateend);
      setDaterange("0");
    }
    setMethod(event.target.value);
  };
  const handleDisplayChange = (event) => { setDisplay(event.target.value); };
  const handleDaterangeChange = (event) => {
    setDatebegin(datesdata.find((obj) => obj.id === event.target.value).datebegin);
    setDateend(datesdata.find((obj) => obj.id === event.target.value).dateend);
    setDaterange(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(getMBMPointData(method === 'raw' ? point.id : point.pointid, datebegin, dateend, method), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        let sorteddata = res.data.sort((a, b) => a.date - b.date);
        setData(sorteddata);
        let csvlinestmp = [];
        let highdata = [];
        if (sorteddata) {
          highdata = sorteddata.map((item) => {
            let dataobj = [];
            dataobj.push(item.date);
            dataobj.push(Number(item.value));

            let csvline = {};
            csvline.date = moment(item.date).utc().format("DD/MM/YYYY HH:mm");
            csvline.value = isNaN(item.value.replace(",", ".")) ? item.value : Number(item.value);
            csvlinestmp.push(csvline);

            return dataobj;
          });
        }
        setCsvLines(csvlinestmp);
        const headerdate = { label: pointdatapagetext.date, key: 'date' };
        const headerval = { label: pointdatapagetext.value, key: "value" };
        setCsvHeaders([headerdate, headerval]);
        setHighchartData(highdata);
        setLoading(false);
      });

  }, [method, datebegin, dateend]);

  useEffect(() => {
    let datesdatatmp = [];
    let nowmoment = moment();
    let onemonthmoment = moment().subtract(1, 'month');
    datesdatatmp.push({ id: "0", name: "1 mois glissant", datebegin: onemonthmoment.format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    for (let i = 1; i <= 24; i++) {
      let substractedmoment = moment().subtract(i, 'month');
      let month = monthnameData.find((obj) => obj.id === substractedmoment.format("MMMM")).name;
      let year = substractedmoment.format("YYYY");
      let datebeginstr = substractedmoment.set('date', 1).format("YYYY-MM-DD");
      let dateendstr = substractedmoment.add(1, 'month').set('date', 1).subtract(1, 'day').format("YYYY-MM-DD"); //go to the end of month
      datesdatatmp.push({ id: "" + i, name: month + " " + year, datebegin: datebeginstr, dateend: dateendstr });
    }
    setDatesdata(datesdatatmp);
  }, []);


  const columns = [
    {
      name: pointdatapagetext.date,
      selector: (row) => row.date,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.date && moment(row.date).isValid()
          ? moment(row.date).utc().format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: pointdatapagetext.value,
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.value ? isNaN(row.value.replace(",", ".")) ? row.value : (new Intl.NumberFormat('fr-FR').format(row.value.replace(",", ".")) + " " + (dico.find((x) => x.id == point.definition)?.unit || "")) : ""
    },
  ]

  const optionsColumnChart = {
    chart: {
      zoomType: "x",
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  const optionsLineChart = {
    chart: {
      zoomType: "x",
      type: "line",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const downloadPng = () => {
    const chartToExport = display === 'barchart' ? optionsColumnChart : display === 'linechart' ? optionsLineChart : "";
    chartToExport.title.text = "";
    chartRef.current.chart.exportChart({
      type: "image/png",
      filename: "export",
    }, chartToExport);
    chartToExport.title.text = "";
    handleClose();
  };

  const downloadCsv = () => {
    chartRef.current.chart.downloadCSV();
    handleClose();
  };

  const downloadXlsx = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;
    div.style.display = 'none';
    document.body.appendChild(div);
    rows = chartRef.current.chart.getDataRows(true);
    var datetime = false;
    if (rows.length > 0) {
      if (rows[0][0] === 'DateTime') {
        datetime = true;
      }
    }
    xlsxRows = rows.slice(1).map((row, rowindex) => {
      return row.map((column, index) => {
        if (rowindex > 0 && index === 0 && datetime) {
          column = moment(column).format("DD/MM/YYYY HH:mm");
        }
        return {
          type: typeof column === 'number' ? 'number' : 'string',
          value: column
        };
      });
    });
    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };
  const downloadXlsxTab = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;

    const headerdate = { value: pointdatapagetext.date, type: 'string' };
    const headerval = { value: pointdatapagetext.value, type: "string" };
    var headers = [headerdate, headerval]


    xlsxRows = data.map((row, rowindex) => {
      let xlsxrow = [{ type: 'string', value: moment(row.date).utc().format("DD/MM/YYYY HH:mm") }, { type: 'string', value: row.value ? isNaN(row.value.replace(",", ".")) ? row.value : new Intl.NumberFormat('fr-FR').format(row.value) : "" }];
      return xlsxrow
    });

    xlsxRows.unshift(headers);

    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };

  return (
    <>
      <form className={classes.root}>
        {point &&
          <GridContainer>
            {
              point.definition !== 1533 ?
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <div>
                    <CustomSelect
                      inputTitle={pointdatapagetext.method}
                      selectValue={method}
                      handleSelectValueChange={handleMethodChange}
                      data={methodData}
                    />
                  </div>
                </GridItem> : <></>
            }

            <GridItem xs={12} sm={12} md={6} lg={6}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.daterange}
                  selectValue={daterange}
                  handleSelectValueChange={handleDaterangeChange}
                  data={datesdata}
                />
              </div>
            </GridItem>
            {
              point.definition !== 1533 ?
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <div>
                    <CustomSelect
                      inputTitle={pointdatapagetext.display}
                      selectValue={display}
                      handleSelectValueChange={handleDisplayChange}
                      data={point.definition === 1533 ? displayDataOnlyTab : displayData}
                    />
                  </div>
                </GridItem>
                : <></>
            }
            {
              loading ?
                <GridItem xs={12} sm={12} md={12} lg={12}><div style={{ paddingTop: "12px", marginLeft: "35%" }}>Récupération des données en cours...</div></GridItem>
                :
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  {display === 'tab' ?
                    <Container>
                      <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="simple-menu"
                          className={"menu-chart"}
                          anchorEl={openMenu}
                          keepMounted
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                          style={menuItemStyle}
                        >
                          <MenuItem onClick={downloadXlsxTab} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem key={Math.random()}>
                            <CSVLink
                              className={'csv'} data={csvLines}
                              headers={csvHeaders} style={downloadCsvButton}
                              filename={`export.csv`} target="_blank"
                              separator={";"}
                            >
                              Télécharger en CSV
                            </CSVLink>
                          </MenuItem>
                        </Menu>
                      </div>
                      <DataTable
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                        dense
                        noDataComponent={<NoData>{pointdatapagetext.nodata}</NoData>}
                        noHeader={true}
                        columns={columns}
                        persistTableHead
                        pagination
                        data={data}
                        paginationComponentOptions={{
                          noRowsPerPage: false,
                          rowsPerPageText: "Lignes par page",
                          rangeSeparatorText: "sur",
                          selectAllRowsItem: false,
                          selectAllRowsItemText: "Selectionner toutes les lignes",
                        }}
                      />
                    </Container>
                    :
                    <>
                      <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="chart-menu"
                          className={"chart-menu"}
                          anchorEl={openMenu}
                          keepMounted
                          aria-haspopup={'menu'}
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={downloadPng} key={`downPng_${Math.random()}`}>
                            Télécharger en PNG
                          </MenuItem>
                          <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem onClick={downloadCsv} key={`downCsv${Math.random()}`}>
                            Télécharger en CSV
                          </MenuItem>
                        </Menu>
                      </div>
                      {display === 'barchart' &&
                        <HighchartsContainer>
                          <HighchartsReact highcharts={Highcharts} options={optionsColumnChart} ref={chartRef} />
                        </HighchartsContainer>
                      }
                      {display === 'linechart' &&
                        <HighchartsContainer>
                          <HighchartsReact highcharts={Highcharts} options={optionsLineChart} ref={chartRef} />
                        </HighchartsContainer>
                      }
                    </>
                  }
                </GridItem>
            }
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewPointDataDialog;
